import {
  ADD_CURRENCY,
  REMOVE_CURRENCY,
  SET_TOP_CURRENCIES,
  UPDATE_CURRENCY,
} from "./types";

const portfolio = localStorage.getItem("portfolio");

const initialBookState = {
  portfolioData: portfolio ? JSON.parse(portfolio) : [],
  TOPCurrencies: [],
};

const portfolioReducer = (state = initialBookState, { type, payload }) => {
  switch (type) {
    case ADD_CURRENCY: {
      const { currency, amount } = payload;
      const index = state.portfolioData.findIndex(
        (el) => el.id === currency.id
      );
      if (index !== -1) {
        let currentPortfolio = [...state.portfolioData];
        const startPrice = currentPortfolio[index].startPrice;
        const lastAmount = currentPortfolio[index].amount;
        currentPortfolio.splice(index, 1);

        return {
          ...state,
          portfolioData: [
            ...currentPortfolio,
            {
              ...currency,
              amount: +lastAmount + +amount,
              startPrice: startPrice,
            },
          ],
        };
      }
      return {
        ...state,
        portfolioData: [
          ...state.portfolioData,
          { ...currency, amount: amount, startPrice: currency.priceUsd },
        ],
      };
    }
    case UPDATE_CURRENCY: {
      const { currency } = payload;
      let currentPortfolio = [...state.portfolioData];
      const index = state.portfolioData.findIndex(
        (el) => el.id === currency.id
      );
      const startPrice = currentPortfolio[index].startPrice;
      const amount = currentPortfolio[index].amount;
      currentPortfolio.splice(index, 1);

      return {
        ...state,
        portfolioData: [
          ...currentPortfolio,
          { ...currency, amount: amount, startPrice: startPrice },
        ],
      };
    }
    case REMOVE_CURRENCY: {
      const { currency } = payload;
      let currentPortfolio = [...state.portfolioData];
      const index = state.portfolioData.findIndex(
        (el) => el.id === currency.id
      );
      currentPortfolio.splice(index, 1);

      return {
        ...state,
        portfolioData: [...currentPortfolio],
      };
    }
    case SET_TOP_CURRENCIES: {
      const { currencies } = payload;
      return {
        ...state,
        TOPCurrencies: [...currencies],
      };
    }
    default: {
      return state;
    }
  }
};

export default portfolioReducer;
